import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";

export const useDeleteSponsor = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (id: string) =>
            client.fetchApi<{ success: boolean; message: string }, {}>({
                endpoint: `sponsors/${id}`,
                method: 'DELETE'
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['sponsors', 'list', selectedOrganization?.id || ''] });
        },
    });
};
